import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BaseWrapperDirective } from 'src/app/shared/classes/base-wrapper';
import { MultiSelectGridItem } from 'src/app/shared/models/MultiSelectGridItem.model';

@Component({
    selector: 'app-multi-select-grid',
    templateUrl: './multi-select-grid.component.html',
    styleUrls: ['./multi-select-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiSelectGridComponent extends BaseWrapperDirective implements OnInit {

  @Input() columns: string[] = [];
  @Input() rows: MultiSelectGridItem[] = [];
  @Input() canSearch: boolean = false;
  @Output() selectionChange = new EventEmitter<MultiSelectGridItem>();

  searchControl = new UntypedFormControl();

  searchValue$: string;
  filteredItems$: MultiSelectGridItem[];
  expandedRow: MultiSelectGridItem;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.filteredItems$ = this.allRows;
  }

  onSearchText(value: string) {
    this.searchValue$ = value;
    this.filterItems();
  }

  onClearSearch() {
    this.searchValue$ = '';
    this.filterItems();
  }

  filterItems() {
    this.filteredItems$ = this.allRows.filter(x => x.value.toLowerCase().includes(this.useableSearchValue));
  }

  get useableSearchValue() {
    return this.searchValue$?.toLowerCase() || '';
  }

  get allRows(): MultiSelectGridItem[] {
    return structuredClone(this.rows);
  }

  toggleRow(row: MultiSelectGridItem) {
    row.isExpanded = !row.isExpanded;
  }

  update(row: MultiSelectGridItem) {
    this.selectionChange.emit(row);
  }

}
